export default __webpack_public_path__ + "static/wall_notes-85206f08c36f14b08f2bde466173a551.svg";